module.exports = __webpack_public_path__ + "img/service_icon.ca9446d9.png";